import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import * as React from 'react';
var SvgWaves = React.forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    viewBox: "0 0 146 20",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    d: "M0 5c7.576 0 7.247-5 14.6-5s7.334 5 14.6 5 7.326-5 14.6-5 7.465 5 14.6 5S65.627 0 73 0c7.373 0 7.22 5 14.6 5s7.322-5 14.6-5 7.121 5 14.6 5c7.479 0 7.475-5 14.6-5s7.214 5 14.6 5v32H0V5z",
    fill: "currentColor",
    stroke: "none"
  }));
});
export default SvgWaves;